import { useNavigate } from 'react-router-dom';
import { PLATFORMS } from 'core/constants/platform.constants';
import { homeRoutePath } from 'core/constants/routes.constants';
import { useAppDispatch, useAppSelector } from 'core/store';
import { setSelectedPlatform } from 'core/store/platform';
import PlatformSelector from 'shared/components/platform-selector/platform-selector';

import './side-nav-header.scss';

export const SideNavHeader = () => {
  const navigate = useNavigate();
  const selectedPlatform = useAppSelector(state => state.platform.selectedPlatform);
  const dispatch = useAppDispatch();

  const handlePlatformSelect = (platformId: number) => {
    navigate(homeRoutePath);
    setTimeout(() => {
      dispatch(setSelectedPlatform(platformId));
    }, 100);
  };

  return (
    <div className="sidenav-header">
      <PlatformSelector onItemSelect={handlePlatformSelect} selectedItem={selectedPlatform} items={PLATFORMS} />
    </div>
  );
};
